<!--
 * @Author: Junjie
 * @Date: 2022-06-02 16:42:09
 * @LastEditTime: 2023-04-10 11:19:18
 * @email: 781433561@qq.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/video/easy-live.vue
-->
<template>
  <a-row :gutter="16" type="flex">
    <a-col :md="4" :sm="24">
      <div style="height: 85vh;background-color: #fff; padding-left: 20px;overflow-y: auto;">
        <a-tree :default-expand-all="true" :treeData="devices" @select="selectDevice" v-if="devices.length>0 ">
          <a-icon slot="online" type="camera" />
        </a-tree>
      </div>
    </a-col>
    <a-col :md="20" :sm="24">
      <a-row align="middle" style="background-color: #fff;padding-top: 1vh;">
        <a-col :span="8"></a-col>
        <a-col :span="8">
          <span>
            分屏:
            <a-radio-group @change="changeSplit" button-style="solid" style="margin-left: 20px;" v-model="splitNum">
              <a-radio-button value="1">单屏</a-radio-button>
              <a-radio-button value="4">四分屏</a-radio-button>
              <a-radio-button value="9">九分屏</a-radio-button>
            </a-radio-group>

            <a-divider type="vertical" />
            <a-button @click="allFullScreen()" icon="fullscreen">全屏</a-button>
          </span>
        </a-col>

        <a-col :span="8">
          <a-row
            :style="{display:'flex', 'justi-content': 'center', 'align-items': 'center', 'position': 'absolute', 'right': '40px'}"
          >
            <a-checkbox @change="checkAllowCarousel()">开启轮播</a-checkbox>
            <a-button-group v-show="allowCarousel">
              <a-button @click="previousVideoGroup" type="primary">
                <a-icon type="up" />
              </a-button>
              <a-button @click="nextVideoGroup" type="primary">
                <a-icon type="down" />
              </a-button>
            </a-button-group>
            <a-tooltip title="保存窗口和视频设置" v-show="!allowCarousel">
              <a-button
                :style="{'margin':'0 29px'}"
                @click="saveFavorConfig()"
                icon="star"
                shape="circle"
                type="primary"
              />
            </a-tooltip>
          </a-row>
        </a-col>
      </a-row>
      <a-card :bordered="false">
        <div
          id="allContainer"
          style="width: 99%;height: 80vh;display: flex;flex-wrap: wrap;align-items: center; justify-content: space-evenly;background-color: #000;"
        >
          <div
            :class="{redborder:playerIdx == (i-1)}"
            :key="i"
            :style="liveStyle"
            @click="playerIdx = (i-1)"
            class="play-box"
            v-for="i in spilt"
          >
            <div
              style="color: #ffffff;font-size: 30px;font-weight: bold;"
              v-if="!videoUrl[i-1]"
            >{{videoName.length>0?videoName[i-1]:i }}</div>
            <template v-else>
              <iframe
                :src="videoUrl[i-1]"
                allow="autoplay"
                allowfullscreen
                frameborder="0"
                style="width:100%;height:100%;"
              ></iframe>
            </template>
          </div>
        </div>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>
  import { getAction, httpAction } from '@/api/manage'
  export default {
    name: "live",
    components: {
    },
    data () {
      return {
        keyWordSearch: '',
        devices: [],
        allVideos: [],
        curVideos: [],
        videoUrl: [''],
        splitNum: "1",
        spilt: 1,//分屏
        playerIdx: 0,//激活播放器

        updateLooper: 0, //数据刷新轮训标志
        count: 15,
        total: 0,
        favorConfig: {},
        //channel
        loading: false,
        allowCarousel: false,
        nowCarouselIndex: 0,
        url: {
          getDeviceTree: "/video/videoDevice/tree",
          getDeviceList: "/video/videoDevice/list",
          getPointsGrouplist: '/monitor/iotModelPointsGroup/list',
          getPointData: '/monitor/data/pointdata',
          addFavorConfig: '/video/sysUserVideoConfig/add',
          editFavorConfig: '/video/sysUserVideoConfig/edit',
          getFavorConfig: '/video/sysUserVideoConfig/list',
        },
        currentVideoList: [],
        videoName: [],
        spinning: true
      };
    },
    mounted () {

    },
    created () {
      this.checkPlayByParam()
      this.getDeviceList();
      this.getFavorConfig();
    },

    computed: {
      liveStyle () {
        let style = { width: '100%', height: '100%' }
        switch (this.spilt) {
          case 4:
            style = { width: '49%', height: '49%' }
            break
          case 9:
            style = { width: '32%', height: '32%' }
            break
        }
        this.$nextTick(() => {
          for (let i = 0; i < this.spilt; i++) {
            const player = this.$refs.player
            player && player[i] && player[i].updatePlayerDomSize()
          }
        })
        return style
      }
    },
    watch: {
      spilt (newValue) {
        let that = this
        for (let i = 1; i <= newValue; i++) {
          if (!that.$refs['player' + i]) {
            continue
          }
          this.$nextTick(() => {
            if (that.$refs['player' + i] instanceof Array) {
              that.$refs['player' + i][0].resize()
            } else {
              that.$refs['player' + i].resize()
            }
          })

        }
        window.localStorage.setItem('split', newValue)
      },
      '$route.fullPath': 'checkPlayByParam'
    },
    destroyed () {
      clearTimeout(this.updateLooper);
    },
    methods: {
      getDeviceList () {
        getAction(this.url.getDeviceTree, {}).then((res) => {
          if (res.success) {
            const tenants = res.result;
            tenants.forEach(tenant => {
              tenant.key = 'tenant_' + tenant.id;
              tenant.title = tenant.name;
              tenant.children.forEach(device => {
                device.key = 'dev_' + device.id;
                device.title = device.videoName;
                this.allVideos.push(device);
              });
            });
            this.devices = tenants;
            this.spinning = false
          } else {
            this.$message.error(res.message)
          }
        });
      },
      changeSplit (e) {
        this.spilt = e.target.value - 0;
        this.nowCarouselIndex = 0;
      },
      checkAllowCarousel () {
        this.allowCarousel = !this.allowCarousel;
        if (!this.allowCarousel && this.favorConfig.videoUrl) {
          this.videoUrl = JSON.parse(this.favorConfig.videoUrl);
        }
        if (this.allowCarousel) {
          this.nowCarouselIndex = 0;
        }
      },
      nextVideoGroup () {
        // this.nowCarouselIndex++
        this.stepVideoGroup(1);

        // this.calculationCurrentVideo()



      },
      previousVideoGroup () {
        // this.nowCarouselIndex--
        // this.calculationCurrentVideo()
        this.stepVideoGroup(-1);
      },
      // 计算翻页展示的video
      calculationCurrentVideo () {

        const allVideos = this.$Jlodash.cloneDeep(this.allVideos)
        const splitAllVideos = this.$Jlodash.chunk(allVideos, this.spilt)
        let currentVideoList = splitAllVideos[this.nowCarouselIndex]

        if (currentVideoList.length < this.spilt) {
          const end = this.spilt - currentVideoList.length
          currentVideoList = currentVideoList.concat(allVideos.slice(0, end))
        }


      },
      stepVideoGroup (n) {
        const arr = this.allVideos;
        const num = this.spilt;

        this.spinning = true
        console.log('arrIds====', arr.map(a => this.$Jlodash.pick(a, ['id', 'title'])))
        if (num >= arr.length) {
          this.curVideos = arr;
        } else {

          let _start, _end = 0
          if (this.nowCarouselIndex === 0) this.nowCarouselIndex = this.spilt
          if (n === 1) {
            _start = this.nowCarouselIndex;
            _end = this.nowCarouselIndex + n * num;
            if (_end > arr.length - 1) {
              _end = _end % arr.length;
              this.curVideos = [...arr.slice(_start, arr.length), ...arr.slice(0, _end)];
            } else {
              this.curVideos = arr.slice(_start, _end);
            }
            this.nowCarouselIndex = _end;
          } else {

            _end = this.nowCarouselIndex;
            _start = this.nowCarouselIndex + n * num;
            if (_start < 0) {
              _start = _start + arr.length;
              this.curVideos = [...arr.slice(_start, arr.length), ...arr.slice(0, _end)];
            } else {
              this.curVideos = arr.slice(_start, _end);
            }
            this.nowCarouselIndex = _start;
          }
        }

        // this.videoUrl = [];
        const videoList = this.curVideos.reduce((pre, cur) => {
          pre.videoUrl.push(cur.liveUrl)
          pre.videoName.push(cur.title)
          return pre
        }, { videoUrl: [], videoName: [] })

        this.videoUrl = videoList.videoUrl
        this.videoName = videoList.videoName
        this.$nextTick(() => {
          this.spinning = false
        })
        // this.spinning = false

        // this.curVideos.forEach(video => {
        //   this.videoUrl.push(video.liveUrl);
        //   this.videoName.push(video.title)
        // });

      },
      destroy (idx) {
        console.log(idx);
        this.clear(idx.substring(idx.length - 1))
      },
      clickEvent: function (data) {
        if (data.channelId && data.subCount == 0) {
          this.sendDevicePush(data)
        }
      },
      contextMenuEvent: function (data) {

      },
      selectDevice (selectedKeys, event) {
        const data = event.node.dataRef;
        const { videoName, liveUrl } = data

        if (data.channelId) {
          //窗口角标越界，从0开始
          if (this.playerIdx > this.spilt - 1) {
            this.playerIdx = 0;
          }

          this.sendDevicePush(data);
          this.$set(this.videoUrl, this.playerIdx, '')
          this.$set(this.videoName, this.playerIdx, videoName)
          this.$nextTick(() => {
            this.$set(this.videoUrl, this.playerIdx, liveUrl)

          })

        }
      },
      //通知设备上传媒体流
      sendDevicePush: function (itemData) {
        // this.save(itemData)
        let deviceId = itemData.deviceId;
        // this.isLoging = true;
        let channelId = itemData.channelId;
        console.log("通知设备推流1：" + deviceId + " : " + channelId);
        let idxTmp = this.playerIdx
        let that = this;
        this.loading = true
        itemData.playUrl = itemData.liveUrl
        that.setPlayUrl(itemData.liveUrl, idxTmp)
      },
      setPlayUrl (url, idx) {

        this.$set(this.videoUrl, idx, url)
        let _this = this
        setTimeout(() => {
          window.localStorage.setItem('videoUrl', JSON.stringify(_this.videoUrl))
        }, 100)

      },
      checkPlayByParam () {
        let { deviceId, channelId } = this.$route.query
        if (deviceId && channelId) {
          this.sendDevicePush({ deviceId, channelId })
        }
      },
      shot (e) {
        const base64ToBlob = function (code) {
          let parts = code.split(';base64,');
          let contentType = parts[0].split(':')[1];
          let raw = window.atob(parts[1]);
          let rawLength = raw.length;
          let uInt8Array = new Uint8Array(rawLength);
          for (let i = 0; i < rawLength; ++i) {
            uInt8Array[i] = raw.charCodeAt(i);
          }
          return new Blob([uInt8Array], {
            type: contentType
          });
        };
        let aLink = document.createElement('a');
        let blob = base64ToBlob(e); //new Blob([content]);
        aLink.download = '截图';
        aLink.href = URL.createObjectURL(blob);
        var event = new Event('click');
        // Listen for the event.
        aLink.addEventListener('click', function (e) { }, false);
        // Dispatch the event.
        aLink.dispatchEvent(event);
      },
      save (item) {
        let dataStr = window.localStorage.getItem('playData') || '[]'
        let data = JSON.parse(dataStr);
        data[this.playerIdx] = item
        window.localStorage.setItem('playData', JSON.stringify(data))
      },
      clear (idx) {
        let dataStr = window.localStorage.getItem('playData') || '[]'
        let data = JSON.parse(dataStr);
        data[idx - 1] = null;
        console.log(data);
        window.localStorage.setItem('playData', JSON.stringify(data))
      },
      allFullScreen () {
        if (this.spilt === 1) {
          //第一个player全屏
          this.$refs.player[0].fullscreenSwich();
        } else {
          let element = document.getElementById('allContainer');
          if (element.requestFullscreen) {
            element.requestFullscreen();
          } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
          } else if (element.webkitRequestFullscreen) {
            element.webkitRequestFullscreen();
          } else if (element.msRequestFullscreen) {
            element.msRequestFullscreen();
          }
        }
      },
      getFavorConfig () {
        const parms = Object.assign(this.favorConfig, {
          userId: this.$store.getters.userInfo.id,
          column: 'id',
          pageNo: 1,
          pageSize: 1,
          superQueryMatchType: 'and'
        });
        getAction(this.url.getFavorConfig, parms).then((res) => {
          const config = res.result.records[0];
          if (res.success && config) {
            this.favorConfig = Object.assign({}, config);
            if (this.favorConfig.videoUrl) {
              this.videoUrl = JSON.parse(this.favorConfig.videoUrl);
              this.spilt = this.favorConfig.spilt - 0;
              this.splitNum = this.spilt + '';
            }
          }
        });
      },
      saveFavorConfig () {
        let httpurl = '';
        let method = '';
        if (!this.favorConfig.id) {
          httpurl += this.url.addFavorConfig;
          method = 'post';
        } else {
          httpurl += this.url.editFavorConfig;
          method = 'put';
        }
        this.favorConfig = Object.assign(this.favorConfig, {
          userId: this.$store.getters.userInfo.id,
          spilt: this.spilt,
          videoUrl: JSON.stringify(this.videoUrl)
        });

        httpAction(httpurl, this.favorConfig, method).then((res) => {
          if (res.success) {
            this.$message.success('保存成功');
          }
        });
      }
    }
  };
</script>
<style>

  .btn {
    margin: 0 10px;
  }

  .btn:hover {
    color: #409eff;
  }

  .btn.active {
    color: #409eff;
  }

  .redborder {
    border: 2px solid red !important;
  }

  .play-box {
    background-color: #000000;
    border: 2px solid #505050;
    display: flex;
    align-items: center;
    justify-content: center;
  }

</style>
<style>

  .videoList {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
  }

  .video-item {
    position: relative;
    width: 15rem;
    height: 10rem;
    margin-right: 1rem;
    background-color: #000000;
  }

  .video-item-img {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 100%;
    height: 100%;
  }

  .video-item-img:after {
    content: '';
    display: inline-block;
    position: absolute;
    z-index: 2;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 3rem;
    height: 3rem;
    /* background-image: url('../assets/loading.png'); */
    background-size: cover;
    background-color: #000000;
  }

  .video-item-title {
    position: absolute;
    bottom: 0;
    color: #000000;
    background-color: #ffffff;
    line-height: 1.5rem;
    padding: 0.3rem;
    width: 14.4rem;
  }

</style>
